export enum TimetableType {
  Regular,
  Calendar,
}
